import { axios } from '@/lib/utils/axios';

import { getResponse } from '../common';
import { API_URLS } from '../query.client';

/**
 * Fetches the tile server conversion log for a TILESET data upload — live
 * pipeline output while the job runs, the stored error/last stage afterwards.
 */
export async function getTilesetLog(id: string): Promise<{ log: string } | null> {
	const response = await axios.get(API_URLS.DATA_UPLOAD.TILESET_LOG(id));
	return getResponse<{ log: string }>(response.data);
}
